<template>
  <horizontal-sliding-list v-if="groups.length" :step="1" navigation-buttons-inside no-mobile-padding>
    <group-horizontal-list-item v-for="group in groups" :key="group.key" :group="group" class="swiper-slide" />
  </horizontal-sliding-list>
</template>

<script>
import HorizontalSlidingList from "@/components/HorizontalSlidingList.vue"
import GroupHorizontalListItem from "@/components/groups/GroupHorizontalListItem.vue"

export default {
  components: {
    HorizontalSlidingList,
    GroupHorizontalListItem
  },
  props: {
    groups: {
      type: Array,
      default: () => []
    }
  }
}
</script>
